import { ProfileTestID } from "@/constants/TestID";
import ProviderCarouselCard from "@/ui/components/profile/ProviderCarouselCard";
import { Text } from "@/ui/core";
import { FlatList, VStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";
import { getPreferredFullName } from "@/utils/user.util";

interface ProviderCarouselProps {
  providers: CareTeamProvider[];
}

const ProviderCarousel = ({ providers }: ProviderCarouselProps) => {
  const baseTestID = ProfileTestID.ProviderTeam;
  return (
    <VStack gap={12}>
      <Text testID={joinTestIDs(baseTestID, "header")} variant="bodyMedium">
        Provider Team
      </Text>
      <FlatList
        data={providers}
        isHorizontal
        renderItem={({ index, item }) => {
          const itemTestID = joinTestIDs(baseTestID, `provider-${index}`);
          const {
            firstName,
            lastName,
            pronouns,
            providerExternalId,
            providerTypeName,
          } = item;
          const fullName = getPreferredFullName({ firstName, lastName });
          return (
            <ProviderCarouselCard
              fullName={fullName}
              pronouns={pronouns}
              providerTypeName={providerTypeName}
              testID={itemTestID}
              userId={providerExternalId}
            />
          );
        }}
        shouldRemoveContentVerticalPadding
        shouldRemoveStyleHorizontalPadding
        testID={ProfileTestID.ProviderTeam}
      />
    </VStack>
  );
};

export type { ProviderCarouselProps };
export default ProviderCarousel;
